import React, { useEffect, useState } from "react"
import { number, string } from "prop-types"
import { NumericFormat } from "react-number-format"
import { getConfig } from "@/constants/config"
import _get from "lodash/get"
import { getPDPUrl } from "@/utils/helper"
import { getEventInfo } from "@/components/ProductDetail/v3/analytics"

const BundleItem = ({ item, t }) => {
  const [currency, setCurrencySign] = useState("")
  const [pdpUrl, setPdpUrl] = useState("")

  useEffect(() => {
    getConfig().then(config => {
      const currency = _get(config, "internationalization.currencySign", "")
      setCurrencySign(currency)
    })

    getPDPUrl(item.category, item.slug)
      .then(url => {
        let bundleUrl = `${url}?skuId=${item.sku}`
        setPdpUrl(bundleUrl)
      })
      .catch(err => console.log(err))
  }, [])

  return (
    <div className="bundle-item">
      <div className="bundle-image">
        <img src={item.img} alt="" />
      </div>
      <div className="bundle-details">
        <a
          href={pdpUrl}
          target="_blank"
          className="gbh-data-layer"
          data-gbh-data-layer={getEventInfo(
            "included items",
            false,
            null,
            null,
            pdpUrl
          )}
          // data-gbh-data-layer-custom={stringProductInfo}
        >
          <h4>{item.productName}</h4>
        </a>
        <p className="bundle-details__color">
          {t("kf.pdp.label.colorOrFinish", "Color/Finish")}: {item.color}
        </p>
        <p className="bundle-details__sku">
          {t("kf.cart.label.sku", "SKU")}: {item.sku}
        </p>
        <p className="bundle-details__qty">
          {t("kf.pdp.qty", "Qty")}: {item.qty}
          <div className="bundle-price">
            {/* <NumericFormat
              value={item.price}
              displayType={"text"}
              thousandSeparator={true}
              prefix={currency}
              decimalScale={2}
              fixedDecimalScale={true}
              thousandsGroupStyle={"lakh"}
            />
            {item.price !== item.mrpprice && ( */}
            <div>
              <span className="">
                <NumericFormat
                  value={item.mrpprice}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={currency}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  thousandsGroupStyle={"lakh"}
                />
              </span>
            </div>
            {/* )} */}
          </div>
        </p>
      </div>
      <div className="bundle-price">
        {/* <NumericFormat
          value={item.price}
          displayType={"text"}
          thousandSeparator={true}
          prefix={currency}
          decimalScale={2}
          fixedDecimalScale={true}
          thousandsGroupStyle={"lakh"}
        />
        {item.price !== item.mrpprice && ( */}
        <div>
          <span>
            <NumericFormat
              value={item.mrpprice}
              displayType={"text"}
              thousandSeparator={true}
              prefix={currency}
              decimalScale={2}
              fixedDecimalScale={true}
              thousandsGroupStyle={"lakh"}
            />
          </span>
        </div>
        {/* )} */}
      </div>
    </div>
  )
}

export default BundleItem

BundleItem.propTypes = {
  item: {
    img: string,
    productName: string,
    color: string,
    sku: string,
    qty: number,
    price: number,
    slug: string,
    category: string,
  },
}

BundleItem.defaultProps = {
  item: {
    img: "",
    productName: "",
    color: "",
    sku: "",
    qty: 1,
    price: 0,
    slug: "",
    category: "",
  },
}
